import Form from "./Form";
import Title from "./Title";
import Ometer from "./Ometer";
import styled from "styled-components";
import { useStore } from "../store";
import HeaderImage from "./HeaderImage";
import Questions from "./Questions";
import Button from "./Button";
import { Copy } from "./Data/Copy";
import { device }  from "../utlis/device";
import { FacebookShareButton} from "react-share";
import useScript from "./useScript";
import Signup from "./Signup";


export const PageContainer = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 0px;
    padding: 50px;
    .signup-step input[type=email] {
        color: black !important;

    }
    .signup-step .su-field-entry {
        color: black !important;
    }
    input#signup-email-address.su-field-entry{
        color: black !important;
    }
`
const Section = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  #signup-email-address.su-field-entry {
    color: black;
  }
  .su-field-entry {
    color: black !important;
  }
  .signup-step button, 
  .signup-step input, 
  .signup-step optgroup, 
  .signup-step select, 
  .signup-step textarea {
    color: black !important;
  }
  component email-address {
  color: black !important;
}
#signup-email-address {
  color: black !important;
}
`

const CopyStyle = styled.div `
  width: 400px;
  padding: 10px;
  @media ${device.mobileL} {
    width: 300px;
  }
  @media ${device.mobileM} {
    width: 280px;
  }
  @media (max-width: 380px) {
    width: 300px;
  }
  @media (max-width: 320px) {
    width: 280px;
  }
  @media ${device.mobileS} {
    width: 80%auto;
  }
`

function Page() {
  const questionMode = useStore((state) => state.questionMode)
  const question = useStore((state) => state.question)
  const me = useStore((state) => state.me)
  const updateQuestionMode = useStore((state) => state.updateQuestionMode)
  useScript('https://public.govdelivery.com/assets/Signup.js')

    const handleStart = () => {
      updateQuestionMode({ questionMode: true })
    }
    return (
      <PageContainer>
        {
          // start page
          !questionMode && 
          <Section>
            <HeaderImage />    
            <Title text="Find out whether you’re Naughty or Nice…"/>
            <CopyStyle>
            {Copy[0].intro}
            </CopyStyle> 
            <Button onClick={handleStart} backgroundColor={"#deb263"}>Next</Button>      
          </Section>
        }
        {
          questionMode && question !== 6 &&
          <Section>           
              <Ometer />
              <Questions />                                  
          </Section> 
        }
        {
          question === 6 &&
          <Section>
            <h1>You're on the {me.isNice ? "Nice" : "Naughty"} List!</h1>
            <CopyStyle> 
              {me.isNice ? Copy[0].nice : Copy[0].naughty }
            </CopyStyle>
            {me.isNice ? 
            <FacebookShareButton url={"https://direc.to/h5VG"} quote={"I'm on Santa's nice list this year! Find out if you are on the Naughty or Nice list"}>
              <img src="/images/fblogo.png" width="40px" alt='ometer' />
              <p>Share your results on Facebook</p>
            </FacebookShareButton> 
            :
            <FacebookShareButton url={"https://direc.to/h5VG"} quote={"I'm on Santa's naughty list this year! Find out if you are on the Naughty or Nice list this year"}>
            <img src="/images/fblogo.png" width="40px" alt='ometer' />
            <p>Share your results on Facebook</p>
          </FacebookShareButton> 
            }
            {/* <Form /> */}
            <p>Entering your email will sign you up for exclusive East Devonly news!</p>
            <Signup />
            <script 
            style={{color: 'black'}}
            src="https://public.govdelivery.com/assets/Signup.js" 
            data-account-code="UKEDDC" 
            data-signup-id="31487" async="" 
            data-width="500" data-delay="0">
            </script>
          </Section>
        }
      </PageContainer>
    );
  }
  
  export default Page;